/** @format */

import React from 'react';
import { Table } from 'semantic-ui-react';

const SaleTableHead = props => {
  return (
    <Table.Row>
      <Table.Cell>
        <small>
          <strong>Prodotto</strong>
        </small>
        <br />
      </Table.Cell>
      <Table.Cell>
        <small>
          <strong>Codice Interno</strong>
        </small>
        <br />
      </Table.Cell>
      <Table.Cell>
        <small>
          <strong>Posizione Scaffale</strong>
        </small>
        <br />
      </Table.Cell>
      <Table.Cell>
        <small>
          <strong>Prezzo</strong>
        </small>
        <br />
      </Table.Cell>
    </Table.Row>
  );
};

export default SaleTableHead;
